// src/utils/dailyTotals.js

/**
 * Aggregate calories, protein, carbs, fat from an array of FoodEntry records.
 * @param {Array} entries
 * @returns {{ calories, protein, carbs, fat }}
 */
export function calculateDailyTotals(entries = []) {
  return entries.reduce(
    (acc, e) => ({
      calories: Math.round(acc.calories + (e.calories || 0)),
      protein:  Math.round(acc.protein  + (e.protein  || 0)),
      carbs:    Math.round(acc.carbs    + (e.carbs    || 0)),
      fat:      Math.round(acc.fat      + (e.fat      || 0)),
    }),
    { calories: 0, protein: 0, carbs: 0, fat: 0 }
  );
}

/**
 * Group food entries by date, returning a map of date → totals.
 */
export function totalsByDate(entries = []) {
  const map = {};
  for (const e of entries) {
    if (!map[e.date]) map[e.date] = { calories: 0, protein: 0, carbs: 0, fat: 0 };
    map[e.date].calories += e.calories || 0;
    map[e.date].protein  += e.protein  || 0;
    map[e.date].carbs    += e.carbs    || 0;
    map[e.date].fat      += e.fat      || 0;
  }
  // Round values
  Object.keys(map).forEach((date) => {
    map[date].calories = Math.round(map[date].calories);
    map[date].protein  = Math.round(map[date].protein);
    map[date].carbs    = Math.round(map[date].carbs);
    map[date].fat      = Math.round(map[date].fat);
  });
  return map;
}
